import Vue from 'vue'
import Vuex from 'vuex'
import defaultAvatar from '@/assets/images/avatar.png'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    sessionToken: null,
    user: 123,
    device: null,
    sidebarOpened: true,
    thisYear: 2019
  },
  getters: {
    nickname (state) {
      return state.user ? state.user.name ? state.user.name : state.user.username : '未登录'
    },
    avatar (state) {
      return (state.user && state.user.avatar) || defaultAvatar
    }
  },
  mutations: {
    setSidebarOpened (state, sidebarOpened) {
      state.sidebarOpened = sidebarOpened
    },
    setDevice (state, device) {
      state.device = device
    },
    setSessionToken (state, sessionToken) {
      state.sessionToken = sessionToken
    },
    setUser (state, user) {
      state.user = user
    },
    setYear (state, thisYear) {
      state.thisYear = thisYear
    },
    initFromStorage (state, opt) {
      for (let i in opt) {
        state[i] = opt[i]
      }
    }
  },
  actions: {}
})
export default store
